import React from 'react';
import ReactDOM from 'react-dom/client';

import PanoraamaContent from './PanoraamaContent';

const root = ReactDOM.createRoot(document.getElementById('panoraama_content'));

root.render(
  <React.StrictMode>
    <PanoraamaContent />
  </React.StrictMode>
);
